'use client';

import { c as _c } from "react/compiler-runtime";
import { getSpartanCustomizeColorId } from '@/app/lcv/components/sections/spartan/products/customize/configurator/color-list/utils';
import { SpartanProductCustomizeColorPanel } from '@/app/lcv/components/sections/spartan/products/customize/configurator/color-panel';
import { SpartanProductCustomizeGradePanel } from '@/app/lcv/components/sections/spartan/products/customize/configurator/grade-panel';
import { useCustomizePreviewCache } from '@/app/lcv/components/sections/spartan/products/customize/configurator/hooks/useCustomizePreviewCache';
import { useCustomizeState } from '@/app/lcv/components/sections/spartan/products/customize/configurator/hooks/useCustomizeState';
import { SpartanProductCustomizePreviewInfo } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-info';
import { SpartanProductCustomizePreviewMedia } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media';
import { getSpartanCustomizePreviewTone } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/preview-tone';
import type { SpartanProductCustomizeConfiguratorProps } from '@/app/lcv/components/sections/spartan/products/customize/configurator/types';
import { SPARTAN_PRODUCT_CUSTOMIZE_TRACKING } from '@/app/lcv/components/sections/spartan/products/customize/tracking';
import { getSpartanCustomizeCalculatorUrl, getSpartanCustomizeColorExtraPrice, getSpartanCustomizeCompareUrl, getSpartanCustomizeExteriorTwoToneSolidColor, getSpartanCustomizePreviewModelName, getSpartanCustomizeTotalPrice } from '@/app/lcv/components/sections/spartan/products/customize/utils';
import { SPARTAN_PRODUCT_LIST_GAP_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/list-gap';
import { getSpartanRevealElementProps, SPARTAN_REVEAL_IMMEDIATE_SCROLL_OFFSET, SPARTAN_REVEAL_PRESET } from '@/app/lcv/components/sections/spartan/products/shared/reveal';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const SpartanProductCustomizeConfigurator = t0 => {
  const $ = _c(109);
  const {
    models,
    defaultModelDocumentId,
    defaultModelsBySubCategory: t1,
    defaultSubCategories,
    initialSubCategoryTitle,
    showSubCategoryTabs: t2,
    modelName,
    fallbackCalculatorUrl,
    fallbackCompareUrl,
    exteriorColorTwoTone,
    styleName
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const defaultModelsBySubCategory = t3;
  const showSubCategoryTabs = t2 === undefined ? true : t2;
  let t4;
  if ($[2] !== defaultModelDocumentId || $[3] !== defaultModelsBySubCategory || $[4] !== defaultSubCategories || $[5] !== initialSubCategoryTitle || $[6] !== models || $[7] !== showSubCategoryTabs) {
    t4 = {
      models,
      defaultModelDocumentId,
      defaultModelsBySubCategory,
      defaultSubCategories,
      initialSubCategoryTitle,
      showSubCategoryTabs
    };
    $[2] = defaultModelDocumentId;
    $[3] = defaultModelsBySubCategory;
    $[4] = defaultSubCategories;
    $[5] = initialSubCategoryTitle;
    $[6] = models;
    $[7] = showSubCategoryTabs;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    subCategories,
    hasSubCategoryTabs,
    selectedSubCategory,
    gradeModels,
    selectedModel,
    selectedColor,
    previewOptions,
    activeView,
    emblaRef,
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
    setSelectedView,
    handleSubCategoryChange,
    handleModelChange,
    handleColorChange
  } = useCustomizeState(t4);
  let t5;
  if ($[9] !== activeView || $[10] !== previewOptions || $[11] !== selectedModel) {
    t5 = {
      selectedModel,
      previewOptions,
      activeView
    };
    $[9] = activeView;
    $[10] = previewOptions;
    $[11] = selectedModel;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    displayedPreviewOptions,
    displayedThumbnailPreviewOptions,
    pendingPreviewOptions,
    pendingThumbnailPreviewOptions,
    handlePreviewImageReady,
    handlePreviewImageError,
    handleThumbnailPreviewImageReady,
    handleThumbnailPreviewImageError,
    prepareColorPreview
  } = useCustomizePreviewCache(t5);
  if (!models.length || !selectedModel) {
    return null;
  }
  const modelLabel = selectedModel.name || selectedModel.title;
  let t6;
  if ($[13] !== modelName || $[14] !== selectedModel || $[15] !== styleName) {
    t6 = getSpartanCustomizePreviewModelName(modelName, styleName, selectedModel);
    $[13] = modelName;
    $[14] = selectedModel;
    $[15] = styleName;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const previewModelName = t6;
  let t7;
  if ($[17] !== selectedColor || $[18] !== selectedModel) {
    t7 = getSpartanCustomizeTotalPrice(selectedModel, selectedColor);
    $[17] = selectedColor;
    $[18] = selectedModel;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const totalPrice = t7;
  const colorName = selectedColor?.color?.nameTh ?? "";
  let t8;
  if ($[20] !== selectedColor) {
    t8 = getSpartanCustomizeColorExtraPrice(selectedColor);
    $[20] = selectedColor;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const colorExtra = t8;
  let t9;
  if ($[22] !== exteriorColorTwoTone || $[23] !== selectedModel) {
    t9 = getSpartanCustomizeExteriorTwoToneSolidColor(selectedModel, exteriorColorTwoTone);
    $[22] = exteriorColorTwoTone;
    $[23] = selectedModel;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const exteriorTwoToneSolidColor = t9;
  let t10;
  if ($[25] !== fallbackCompareUrl || $[26] !== selectedColor || $[27] !== selectedModel) {
    t10 = getSpartanCustomizeCompareUrl(selectedModel, selectedColor) ?? fallbackCompareUrl;
    $[25] = fallbackCompareUrl;
    $[26] = selectedColor;
    $[27] = selectedModel;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const compareUrl = t10;
  let t11;
  if ($[29] !== fallbackCalculatorUrl || $[30] !== selectedColor || $[31] !== selectedModel) {
    t11 = getSpartanCustomizeCalculatorUrl(selectedModel, selectedColor) ?? fallbackCalculatorUrl;
    $[29] = fallbackCalculatorUrl;
    $[30] = selectedColor;
    $[31] = selectedModel;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const calculatorUrl = t11;
  const isInteriorView = activeView === "interior";
  const theme = styleName === "x-series" ? "dark" : "light";
  let t12;
  let t13;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = cn("grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_23.5rem]", SPARTAN_PRODUCT_LIST_GAP_CLASS_NAME);
    t13 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.configurator
    });
    $[33] = t12;
    $[34] = t13;
  } else {
    t12 = $[33];
    t13 = $[34];
  }
  let t14;
  if ($[35] !== selectedColor || $[36] !== styleName) {
    t14 = getSpartanCustomizePreviewTone(getSpartanCustomizeColorId(selectedColor), styleName);
    $[35] = selectedColor;
    $[36] = styleName;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const t15 = styleName === "x-series";
  let t16;
  if ($[38] !== activeView || $[39] !== calculatorUrl || $[40] !== compareUrl || $[41] !== displayedPreviewOptions || $[42] !== displayedThumbnailPreviewOptions || $[43] !== emblaRef || $[44] !== handlePreviewImageError || $[45] !== handlePreviewImageReady || $[46] !== handleThumbnailPreviewImageError || $[47] !== handleThumbnailPreviewImageReady || $[48] !== modelLabel || $[49] !== nextBtnDisabled || $[50] !== onNextButtonClick || $[51] !== onPrevButtonClick || $[52] !== pendingPreviewOptions || $[53] !== pendingThumbnailPreviewOptions || $[54] !== prevBtnDisabled || $[55] !== previewModelName || $[56] !== setSelectedView || $[57] !== t14 || $[58] !== t15 || $[59] !== totalPrice) {
    t16 = <SpartanProductCustomizePreviewMedia modelName={previewModelName} modelLabel={modelLabel} previewTone={t14} isDarkStudio={t15} totalPrice={totalPrice} compareUrl={compareUrl} calculatorUrl={calculatorUrl} previewOptions={displayedPreviewOptions} thumbnailPreviewOptions={displayedThumbnailPreviewOptions} activeView={activeView} emblaRef={emblaRef} prevBtnDisabled={prevBtnDisabled} nextBtnDisabled={nextBtnDisabled} onPrevButtonClick={onPrevButtonClick} onNextButtonClick={onNextButtonClick} onSelectView={setSelectedView} pendingPreviewOptions={pendingPreviewOptions} pendingThumbnailPreviewOptions={pendingThumbnailPreviewOptions} onPreviewImageReady={handlePreviewImageReady} onPreviewImageError={handlePreviewImageError} onThumbnailPreviewImageReady={handleThumbnailPreviewImageReady} onThumbnailPreviewImageError={handleThumbnailPreviewImageError} />;
    $[38] = activeView;
    $[39] = calculatorUrl;
    $[40] = compareUrl;
    $[41] = displayedPreviewOptions;
    $[42] = displayedThumbnailPreviewOptions;
    $[43] = emblaRef;
    $[44] = handlePreviewImageError;
    $[45] = handlePreviewImageReady;
    $[46] = handleThumbnailPreviewImageError;
    $[47] = handleThumbnailPreviewImageReady;
    $[48] = modelLabel;
    $[49] = nextBtnDisabled;
    $[50] = onNextButtonClick;
    $[51] = onPrevButtonClick;
    $[52] = pendingPreviewOptions;
    $[53] = pendingThumbnailPreviewOptions;
    $[54] = prevBtnDisabled;
    $[55] = previewModelName;
    $[56] = setSelectedView;
    $[57] = t14;
    $[58] = t15;
    $[59] = totalPrice;
    $[60] = t16;
  } else {
    t16 = $[60];
  }
  let t17;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.controlsColumn
    });
    $[61] = t17;
  } else {
    t17 = $[61];
  }
  const t18 = selectedSubCategory?.documentId;
  let t19;
  if ($[62] !== gradeModels || $[63] !== handleModelChange || $[64] !== handleSubCategoryChange || $[65] !== hasSubCategoryTabs || $[66] !== selectedModel || $[67] !== subCategories || $[68] !== t18 || $[69] !== theme) {
    t19 = <SpartanProductCustomizeGradePanel theme={theme} models={gradeModels} selectedModel={selectedModel} onSelectModel={handleModelChange} hasSubCategoryTabs={hasSubCategoryTabs} subCategories={subCategories} selectedSubCategoryDocumentId={t18} onSubCategoryChange={handleSubCategoryChange} />;
    $[62] = gradeModels;
    $[63] = handleModelChange;
    $[64] = handleSubCategoryChange;
    $[65] = hasSubCategoryTabs;
    $[66] = selectedModel;
    $[67] = subCategories;
    $[68] = t18;
    $[69] = theme;
    $[70] = t19;
  } else {
    t19 = $[70];
  }
  let t20;
  if ($[71] !== colorExtra || $[72] !== colorName || $[73] !== exteriorTwoToneSolidColor || $[74] !== handleColorChange || $[75] !== isInteriorView || $[76] !== prepareColorPreview || $[77] !== selectedColor || $[78] !== selectedModel.colors || $[79] !== selectedModel.interiorColor || $[80] !== theme) {
    t20 = <SpartanProductCustomizeColorPanel theme={theme} colors={selectedModel.colors} selectedColor={selectedColor} onSelectColor={handleColorChange} onPrepareColorPreview={prepareColorPreview} colorName={colorName} colorExtra={colorExtra} interiorColor={selectedModel.interiorColor} exteriorTwoToneSolidColor={exteriorTwoToneSolidColor} isInteriorView={isInteriorView} />;
    $[71] = colorExtra;
    $[72] = colorName;
    $[73] = exteriorTwoToneSolidColor;
    $[74] = handleColorChange;
    $[75] = isInteriorView;
    $[76] = prepareColorPreview;
    $[77] = selectedColor;
    $[78] = selectedModel.colors;
    $[79] = selectedModel.interiorColor;
    $[80] = theme;
    $[81] = t20;
  } else {
    t20 = $[81];
  }
  const t21 = theme === "dark" ? "bg-gray-900" : "bg-silver-100";
  let t22;
  if ($[82] !== t21) {
    t22 = cn("order-5 overflow-hidden rounded-lg lg:hidden", t21);
    $[82] = t21;
    $[83] = t22;
  } else {
    t22 = $[83];
  }
  let t23;
  let t24;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewInfoMobile
    });
    t24 = getSpartanRevealElementProps({
      preset: SPARTAN_REVEAL_PRESET.collection,
      scrollOffset: SPARTAN_REVEAL_IMMEDIATE_SCROLL_OFFSET
    });
    $[84] = t23;
    $[85] = t24;
  } else {
    t23 = $[84];
    t24 = $[85];
  }
  let t25;
  if ($[86] !== calculatorUrl || $[87] !== compareUrl || $[88] !== modelLabel || $[89] !== previewModelName || $[90] !== theme || $[91] !== totalPrice) {
    t25 = <SpartanProductCustomizePreviewInfo placement="mobile" modelName={previewModelName} modelLabel={modelLabel} totalPrice={totalPrice} compareUrl={compareUrl} calculatorUrl={calculatorUrl} tone={theme} />;
    $[86] = calculatorUrl;
    $[87] = compareUrl;
    $[88] = modelLabel;
    $[89] = previewModelName;
    $[90] = theme;
    $[91] = totalPrice;
    $[92] = t25;
  } else {
    t25 = $[92];
  }
  let t26;
  if ($[93] !== t22 || $[94] !== t23 || $[95] !== t24 || $[96] !== t25) {
    t26 = <div className={t22} {...t23} {...t24}>{t25}</div>;
    $[93] = t22;
    $[94] = t23;
    $[95] = t24;
    $[96] = t25;
    $[97] = t26;
  } else {
    t26 = $[97];
  }
  let t27;
  if ($[98] !== t20 || $[99] !== t26) {
    t27 = <div className="contents">{t20}{t26}</div>;
    $[98] = t20;
    $[99] = t26;
    $[100] = t27;
  } else {
    t27 = $[100];
  }
  let t28;
  if ($[101] !== t17 || $[102] !== t19 || $[103] !== t27) {
    t28 = <div className="contents" {...t17}>{t19}{t27}</div>;
    $[101] = t17;
    $[102] = t19;
    $[103] = t27;
    $[104] = t28;
  } else {
    t28 = $[104];
  }
  let t29;
  if ($[105] !== t13 || $[106] !== t16 || $[107] !== t28) {
    t29 = <div className={t12} {...t13}>{t16}{t28}</div>;
    $[105] = t13;
    $[106] = t16;
    $[107] = t28;
    $[108] = t29;
  } else {
    t29 = $[108];
  }
  return t29;
};